/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateOrganizationRequestSubscriptionPaymentFrequency } from './CreateOrganizationRequestSubscriptionPaymentFrequency';
import {
    CreateOrganizationRequestSubscriptionPaymentFrequencyFromJSON,
    CreateOrganizationRequestSubscriptionPaymentFrequencyFromJSONTyped,
    CreateOrganizationRequestSubscriptionPaymentFrequencyToJSON,
    CreateOrganizationRequestSubscriptionPaymentFrequencyToJSONTyped,
} from './CreateOrganizationRequestSubscriptionPaymentFrequency';

/**
 * 
 * @export
 * @interface CreateOrganizationRequestSubscription
 */
export interface CreateOrganizationRequestSubscription {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestSubscription
     */
    plan: string;
    /**
     * 
     * @type {CreateOrganizationRequestSubscriptionPaymentFrequency}
     * @memberof CreateOrganizationRequestSubscription
     */
    paymentFrequency: CreateOrganizationRequestSubscriptionPaymentFrequency;
}

/**
 * Check if a given object implements the CreateOrganizationRequestSubscription interface.
 */
export function instanceOfCreateOrganizationRequestSubscription(value: object): value is CreateOrganizationRequestSubscription {
    if (!('plan' in value) || value['plan'] === undefined) return false;
    if (!('paymentFrequency' in value) || value['paymentFrequency'] === undefined) return false;
    return true;
}

export function CreateOrganizationRequestSubscriptionFromJSON(json: any): CreateOrganizationRequestSubscription {
    return CreateOrganizationRequestSubscriptionFromJSONTyped(json, false);
}

export function CreateOrganizationRequestSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationRequestSubscription {
    if (json == null) {
        return json;
    }
    return {
        
        'plan': json['plan'],
        'paymentFrequency': CreateOrganizationRequestSubscriptionPaymentFrequencyFromJSON(json['paymentFrequency']),
    };
}

export function CreateOrganizationRequestSubscriptionToJSON(json: any): CreateOrganizationRequestSubscription {
    return CreateOrganizationRequestSubscriptionToJSONTyped(json, false);
}

export function CreateOrganizationRequestSubscriptionToJSONTyped(value?: CreateOrganizationRequestSubscription | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan': value['plan'],
        'paymentFrequency': CreateOrganizationRequestSubscriptionPaymentFrequencyToJSON(value['paymentFrequency']),
    };
}

